import { IMessageFilter } from "../../types/message";
import api from "../axiosConfig";
import { MESSSAGES } from "../endPoint";

export const getMessages = async (id: string, data: IMessageFilter) => {
  try {
    const response = await api.get(MESSSAGES(id), {
      params: {
        toIndex: data.toIndex,
        limit: data.limit,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
